import "./DashboardWhiteItemContainer.scss"

export default function DashboardWhiteItemContainer({children, type = DashboardWhiteItemContainerType.FOUR_COLUMN}) {
    return (
        <div className={`dashboardWhiteItemContainerBaseContainer ${type}`}>
            {children}
        </div>
    )
}


export const DashboardWhiteItemContainerType = {
    ONE_COLUMN: "DASHBOARD_WHITE_ITEM_ONE_COLUMN",
    TWO_COLUMN: "DASHBOARD_WHITE_ITEM_TWO_COLUMN",
    THREE_COLUMN: "DASHBOARD_WHITE_ITEM_THREE_COLUMN",
    FOUR_COLUMN: "DASHBOARD_WHITE_ITEM_FOUR_COLUMN",
    FIVE_COLUMN: "DASHBOARD_WHITE_ITEM_FIVE_COLUMN",
}


